import { createGlobalStyle } from 'styled-components';
 
const GlobalStyle = createGlobalStyle`
  :root {
    --sidenav-itemMenu-color:  ${(props) => props.menuStyles.menuColorItem};
    --sidenav-itemMenuHover-color: ${(props) => props.menuStyles.menuColorItemHover};
    --sidenav-itemActive-color: ${(props) => props.menuStyles.menuColorItemActive};
    --sidenav-background-color: ${(props) => props.menuStyles.bgColorMenu};

  }
  .ant-btn-primary  {
    background-color: ${(props) => props.btnColorPrimary} !important;
    border-color:${(props) => props.btnColorPrimary} !important;
  }
  .ant-btn-primary:focus, .ant-btn-primary:hover{
    background-color: ${(props) => props.btnColorPrimary} !important;
    border-color:${(props) => props.btnColorPrimary} !important;
    opacity: .8;
  }
  .fxt-template-layout13 .fxt-bg-wrap:before{
    background-color: ${(props) => props.btnColorPrimary} !important;
  }
  .vc-commonTable .vc-tableHead, .vc-commonTable th:first-child{
    background-color: ${(props) => props.btnColorPrimary} !important;
  }
  .ant-menu-sub.ant-menu-inline > .ant-menu-item, 
  .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    height: 35px;
    line-height: 35px;
    list-style-position: inside;
    list-style-type: disc;
  }
  .ant-menu-item-group{
    padding:9px
  }
  .ant-menu-dark .ant-menu-submenu-title:hover{
    color:var(--sidenav-itemMenuHover-color) !important;
  }
  .ant-menu-dark .ant-menu-item:hover {
    background-color: rgba(255, 255, 255, .1) !important;
    padding:0 16px;
    border-radius: 10px;
    color:var(--sidenav-itemMenuHover-color) !important
  }
  .ant-menu-inline .ant-menu-item, 
  .ant-menu-inline .ant-menu-submenu-title, 
  .ant-menu-vertical .ant-menu-item, 
  .ant-menu-vertical .ant-menu-submenu-title, 
  .ant-menu-vertical-left .ant-menu-item, 
  .ant-menu-vertical-left .ant-menu-submenu-title, 
  .ant-menu-vertical-right .ant-menu-item, 
  .ant-menu-vertical-right .ant-menu-submenu-title {
    height: 35px;
    margin-top: 4px;
    margin-bottom: 4px;
    padding: 0px 16px;
    overflow: hidden;
    line-height: 35px;
    text-overflow: ellipsis;
  }
  .ant-menu-inline-collapsed,.ant-layout-sider-children .ant-menu.ant-menu-inline-collapsed{
    height:100% !important
  }
  .ant-menu-dark .ant-menu-submenu-open.submenu-esp, .ant-menu-submenu-open {
    border-top: solid 1px #74777c;
    // background: #0000001a;
    // background: yellow;
    border-radius: 4px;
  }
  .ant-menu-dark .ant-menu-item-selected::after{
    
  }
   .ant-menu.ant-menu-dark{
    background:transparent !important;
    color:var(--sidenav-itemMenu-color) !important;
  }

  /*cuando esté activo el item del menú*/
  .ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon, 
  .ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon + span, 
  .ant-menu-dark .ant-menu-item-selected .anticon, 
  .ant-menu-dark .ant-menu-item-selected .anticon + span,  
  .ant-menu-dark .ant-menu-submenu-open{
    color:var(--sidenav-itemActive-color) !important;
  }
  /*TAMBIEN INCLUYE EL ITEM DESPLEGABLE ACTIVO*/

  .ant-menu-dark .ant-menu-item, .ant-menu-dark .ant-menu-item-group-title, .ant-menu-dark .ant-menu-item > a, .ant-menu-dark .ant-menu-item > span > a{
    color:var(--sidenav-itemMenu-color) !important;
  }
  .virtud-custom-color-mobile .ant-drawer-content{

  }
  .virtud-custom-color, .mobile-nav-menu
  {
    background: var(--sidenav-background-color) !important;
  }

  .ant-menu-dark .ant-menu-sub, .ant-menu.ant-menu-dark .ant-menu-sub{
    color:var(--sidenav-itemMenu-color) !important;
    background: var(--sidenav-background-color) !important;

  }
`;
 
export default GlobalStyle;